// extracted by mini-css-extract-plugin
export var chevron = "_c2-2";
export var dropdownItems = "_c2-0";
export var item = "_c2-1";